<app-modal [active]="batchStarted" (modalClosed)="batchStarted = false">
    <app-batch-download></app-batch-download>
</app-modal>

<ng-container *ngIf="isAllowedToEdit; else notAllowed">
    <div style="background-color: #f7f7f7; padding: 3rem">
        <div class="columns">
            <div class="column is-1"></div>
            <div class="column is-flex is-justify-content-space-between" style="color: #35566E; font-size: 23px">
                <div class="columns">
                    <div class="column">
                        <p style="white-space: nowrap;">Meine Bestellungen</p>
                    </div>
                    <div class="column" style="border-left: 2px solid #d7d7d7">
                        <a id="downloads-button" routerLink="/batch-download" style="color: #d7d7d7;">Downloads</a>
                    </div>
                </div>
            </div>
            <div class="column is-1"></div>
            <div class="column search">
                <div class="columns">
                    <div class="column">
                        <span>
                            <input (keyup)="searchProperties()" disabled matTooltip="Demnächst verfügbar" [(ngModel)]="searchText" class="input" placeholder="Suche"
                                   style="width: 300px; border-bottom: none !important;background-color: #ffffff" type="text"
                            >
                        </span>
                    </div>
                    <div class="column">
                        <span style="float: right; padding: 8px">
                            <svg height="24.093" viewBox="0 0 29.086 29.093" width="24.086" xmlns="http://www.w3.org/2000/svg">
                                <path d="M33.245,31.481l-8.089-8.165a11.528,11.528,0,1,0-1.75,1.772L31.442,33.2a1.245,1.245,0,0,0,1.757.045A1.253,1.253,
                                    0,0,0,33.245,31.481ZM16.1,25.186a9.1,9.1,0,1,1,6.438-2.666A9.047,9.047,0,0,1,16.1,25.186Z"
                                      data-name="Icon ionic-ios-search"
                                      fill="#707070"
                                      id="Icon_ionic-ios-search" transform="translate(-4.5 -4.493)"
                                />
                            </svg>
                        </span>
                    </div>
                </div>
            </div>
            <div class="column is-1"></div>
        </div>

        <!--properties: search results-->
        <ng-container *ngIf="searchText; else showOrders">
            <div class="columns mt-5" style="margin-bottom: 0">
                <div class="column is-2"></div>
                <div class="column"
                     style="background-color: #336E99; border: 1px solid; border-bottom: none;  border-radius: 10px; color: white">
                    <div class="columns">
                        <div class="column" style="text-align: center">Objekt-ID</div>
                        <div class="column is-3">Straße</div>
                        <div class="column is-1">Nr.</div>
                        <div class="column is-1">PLZ</div>
                        <div class="column is-2">Stadt</div>
                        <div class="column"></div>
                    </div>
                </div>
                <div class="column is-2"></div>
            </div>

            <div *ngIf="propertiesBySearchTerm.length > 0" id="outer-container">
                <div *ngFor="let property of propertiesBySearchTerm" class="columns mt-5" id="property">
                    <div class="column is-2"></div>
                    <div class="column" style="background-color: #ffffff; border-radius: 10px;height: 120px">
                        <div class="columns" style="height: 120px">
                            <div class="column c1 has-text-centered">
                                <div>
                                    {{property.id}}
                                    <div *ngIf="property.name" style="position: relative;font-size: 12px; color: #707070">
                                        {{property.name}}
                                    </div>
                                </div>
                            </div>
                            <div class="column c1 is-3">
                                {{property.street}}
                            </div>
                            <div class="column c1 is-1">
                                {{property.house_number}}
                            </div>
                            <div class="column c1 is-1">
                                {{property.zip}}
                            </div>
                            <div class="column c1 is-2">
                                {{property.town}}
                            </div>
                            <div class="column c1 has-text-right">
                                <svg
                                        *ngIf="containsPropertyDocumentWithUnseenInformation(property) && !hasPropertyNecessaryActions(property)"
                                        height="20"
                                        style="position: absolute; z-index: 1; transform: translate(106px,-11px)"
                                        viewBox="0 0 24 24" width="20"
                                        xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="12" cy="12" data-name="Ellipse 29" fill="#e64b4b" id="Ellipse_29" r="12"/>
                                </svg>
                                <svg
                                        *ngIf="containsPropertyDocumentWithUnseenInformation(property) && !hasPropertyNecessaryActions(property)"
                                        data-name="Komponente 4 – 1"
                                        height="25.33" id="Komponente_4_1"
                                        style="position: absolute; z-index: 1; transform: translate(105px,-14px)"
                                        viewBox="0 0 25.33 25.33"
                                        width="25.33"
                                        xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20.665,8A12.665,12.665,0,1,0,33.33,20.665,12.667,12.667,0,0,0,20.665,8Zm0,5.618a2.145,2.145,0,1,1-2.145,2.145A2.145,2.145,0,0,1,20.665,13.618Zm2.86,12.971a.613.613,0,0,1-.613.613H18.418a.613.613,0,0,1-.613-.613V25.363a.613.613,0,0,1,.613-.613h.613V21.482h-.613a.613.613,0,0,1-.613-.613V19.644a.613.613,0,0,1,.613-.613h3.268a.613.613,0,0,1,.613.613v5.107h.613a.613.613,0,0,1,.613.613Z"
                                          data-name="Pfad 613"
                                          fill="#d7d7d7"
                                          id="Pfad_613" transform="translate(-8 -8)"/>
                                </svg>
                                <svg *ngIf="hasPropertyNecessaryActions(property)" height="25.063"
                                     style="position: absolute; z-index: 1; transform: translate(105px,-14px)"
                                     viewBox="0 0 25.063 25.063" width="25.063"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.532,0A12.532,12.532,0,1,0,25.063,12.532,12.532,12.532,0,0,0,12.532,0ZM11.357,7.44a1.175,1.175,0,1,1,2.35,0v6.266a1.175,1.175,0,1,1-2.35,0Zm1.175,12.14a1.539,1.539,0,1,1,1.539-1.539,1.539,1.539,0,0,1-1.539,1.539Z"
                                          data-name="Pfad 621"
                                          fill="#de1507"
                                          id="Pfad_621"/>
                                </svg>
                                <a [state]="[property]" class="details"
                                   routerLink="/order_object/{{property.id}}">Details</a>
                            </div>
                        </div>
                    </div>
                    <div class="column is-2"></div>
                </div>
            </div>

            <div *ngIf="propertiesBySearchTerm.length === 0" class="columns mt-5">
                <div class="column is-2"></div>
                <div class="column" style="background-color: #ffffff; border-radius: 10px;height: 120px">
                    <div class="columns" style="height: 120px">
                        <div class="column c1 has-text-centered">
                            <p>Es konnte kein passendes Objekt gefunden werden.</p>
                        </div>
                    </div>
                </div>
                <div class="column is-2"></div>
            </div>

        </ng-container>


        <!--orders-->
        <ng-template #showOrders>
            <!-- Custom Grid Start -->
            <div class="columns mt-5" style="margin-bottom: 1.5em;">
                <div class="column is-1"></div>
                <div class="column control_column">
                    <div class="permission-grid" [formGroup]="controlGroup">
                        <div class="permission-grid-item back">
                            <a class="is-clickable color-white mr-4 is-vertical-middle is-size-4" (click)="navigateBack()">
                                <fa-icon [icon]="faArrowLeft"></fa-icon>
                            </a>
                        </div>
                        <div class="permission-grid-item group-access start">
                            <label>
                                Sie bearbeiten die Berechtigungen der Nutzergruppe
                                <div class="select is-rounded is-small">
                                    <select [formControl]="selectedUserGroup">
                                        <option *ngFor="let group of userGroups; let i = index;" [value]="i">{{group.name}}</option>
                                    </select>
                                </div>
                            </label>
                        </div>
                        <div class="permission-grid-item toggle-all">
                            <label class="checkbox">
                                <input type="checkbox" formControlName="changeAll">
                                Einstellungen für alle Aufträge übernehmen
                            </label>
                        </div>
                        <div class="permission-grid-item edit">
                            <span><a class="permissions" (click)="openUserGroupDialog()" style="vertical-align: middle">Nutzergruppe verwalten</a></span>
                        </div>
                        <div class="permission-grid-item cancel">
                            <span><a routerLink="/order" class="permissions cancel" style="vertical-align: middle">Abbrechen</a></span>
                        </div>
                        <div class="permission-grid-item save">
                            <span><a class="permissions" (click)="savePermissions()" style="vertical-align: middle">Speichern</a></span>
                        </div>
                    </div>
                </div>
                <div class="column is-1"></div>
            </div>
            <!-- Custom Grid End-->
            <div class="columns" style="margin-bottom: 0">
                <div class="column is-1"></div>
                <div class="column"
                     style="background-color: #336E99; border: 1px solid; border-bottom: none;  border-radius: 10px; color: white">
                    <div class="columns">
                        <div class="column is-2"></div>
                        <div class="column is-2">Auftrag</div>
                        <div class="column is-2">Bestelldatum</div>
                        <div class="column is-2">Details</div>
                        <div class="column in-4">Berechtigungen</div>
                    </div>
                </div>
                <div class="column is-1"></div>
            </div>

            <div *ngIf="!orders || orders.length === 0" class="columns">
                <div class="column has-text-centered">
                    Sie haben noch keine Bestellung aufgegeben.
                </div>
            </div>

            <ng-container *ngIf="orders">
                <div *ngFor="let order of orders | keyvalue : orderIdDescending" class="columns mt-5">
                    <div class="column is-1"></div>
                    <div class="column" style="background-color: #ffffff; border-radius: 10px;height: 120px">
                        <div class="columns delicate-shadow" style="height: 120px;">
                          <div class="column is-2 is-flex is-align-items-center is-justify-content-center">
                            <circle-progress class="is-flex is-align-items-center" *ngIf="hasOrderStatistics(order.value)"
                                             subtitle="{{progress(order.value) |number: '1.0-2':'de'}}%"
                                             [percent]="progress(order.value)"
                                             [backgroundStrokeWidth]=0
                                             [backgroundPadding]=5
                                             [radius]=35
                                             [space]=-2
                                             [outerStrokeWidth]=3
                                             [outerStrokeColor]="'#73B1D6'"
                                             [outerStrokeLinecap]="'butt'"
                                             [innerStrokeColor]="'#f7f7f7'"
                                             [innerStrokeWidth]=3
                                             [subtitleColor]="'#35566E'"
                                             [titleFontWeight]="'700'"
                                             [subtitleFontSize]="'18'"
                                             [animateTitle]=false
                                             [animationDuration]=1000
                                             [showTitle]=false
                                             [showUnits]=false
                                             [showBackground]=false
                                             [clockwise]=true
                                             [responsive]=false
                                             [startFromZero]=false
                                             [lazy]=true
                            ></circle-progress>
                            <div *ngIf="!hasOrderStatistics(order.value)" class="st31 is-flex is-justify-content-center is-align-items-center">
                              <ngx-skeleton-loader [theme]="{'width':'70px','height':'70px'}" appearance="circle" count="1"></ngx-skeleton-loader>
                            </div>
                          </div>
                            <div class="column is-2 c1">
                                {{order.value.orderid}}
                                <div *ngIf="order.value.name" style="position: relative;font-size: 12px; color: #707070">
                                    {{order.value.name}}
                                </div>
                            </div>
                            <div class="column is-2 c1">{{order.value.entrydate | date:'dd.MM.yyyy'}}</div>
                            <div class="column is-2 c2">
                                <svg *ngIf="containsOrderDocumentWithUnseenInformation(order.value) && !hasOrderPropertyWithNecessaryActions(order.value)"
                                     height="20" style="position: absolute; z-index: 1; transform: translate(106px,2px)"
                                     viewBox="0 0 24 24" width="20"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="12" cy="12" data-name="Ellipse 29" fill="#e64b4b" id="Ellipse_29" r="12"/>
                                </svg>
                                <svg *ngIf="containsOrderDocumentWithUnseenInformation(order.value) && !hasOrderPropertyWithNecessaryActions(order.value)"
                                     data-name="Komponente 4 – 1"
                                     height="25.33" id="Komponente_4_1"
                                     style="position: absolute; z-index: 1; transform: translate(105px,0px)"
                                     viewBox="0 0 25.33 25.33"
                                     width="25.33" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20.665,8A12.665,12.665,0,1,0,33.33,20.665,12.667,12.667,0,0,0,20.665,8Zm0,5.618a2.145,2.145,0,1,1-2.145,2.145A2.145,2.145,0,0,1,20.665,13.618Zm2.86,12.971a.613.613,0,0,1-.613.613H18.418a.613.613,0,0,1-.613-.613V25.363a.613.613,0,0,1,.613-.613h.613V21.482h-.613a.613.613,0,0,1-.613-.613V19.644a.613.613,0,0,1,.613-.613h3.268a.613.613,0,0,1,.613.613v5.107h.613a.613.613,0,0,1,.613.613Z"
                                          data-name="Pfad 613"
                                          fill="#d7d7d7"
                                          id="Pfad_613" transform="translate(-8 -8)"/>
                                </svg>
                                <svg *ngIf="hasOrderPropertyWithNecessaryActions(order.value)" height="25.063"
                                     style="position: absolute; z-index: 1; transform: translate(105px,0px)"
                                     viewBox="0 0 25.063 25.063" width="25.063"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.532,0A12.532,12.532,0,1,0,25.063,12.532,12.532,12.532,0,0,0,12.532,0ZM11.357,7.44a1.175,1.175,0,1,1,2.35,0v6.266a1.175,1.175,0,1,1-2.35,0Zm1.175,12.14a1.539,1.539,0,1,1,1.539-1.539,1.539,1.539,0,0,1-1.539,1.539Z"
                                          data-name="Pfad 621"
                                          fill="#de1507"
                                          id="Pfad_621"/>
                                </svg>
                                <span>
                            <a [state]="order" class="details" routerLink="/order_details/{{order.value.orderid}}" style="vertical-align: middle">
                                Details
                            </a>
                        </span>
                            </div>
                            <div class="column is-4" style="display: flex; align-items: center; justify-content: start">
                                <div class="icon-permissions">
                                    <mat-icon class="noselect" [class.active_permissions_icon]="order.value.permission?.hasOwnProperty('scopes') && order.value.permission!.scopes.includes('VIEW')" (click)="setPermissionEntry(order.value.orderid, 'VIEW')" style="transform: scale(1.5);">remove_red_eye</mat-icon>
                                    <mat-icon class="noselect" [class.active_permissions_icon]="order.value.permission?.hasOwnProperty('scopes') && order.value.permission!.scopes.includes('DOWNLOAD')" (click)="setPermissionEntry(order.value.orderid, 'DOWNLOAD')" style="transform: scale(1.5);">archive</mat-icon>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column is-1"></div>
                </div>
            </ng-container>

            <ng-container *ngIf="(!orders || orders.length === 0) && !requestedOrders">
                <ng-container *ngFor="let _ of [].constructor(5)">
                    <div class="columns">
                        <div class="column is-1"></div>
                        <div class="column">
                            <ngx-skeleton-loader
                                [theme]="{'animation':'none','margin-top':'10px', 'margin-bottom':'-10px', 'height':'110px'}"
                                appearance="line" count="1">
                            </ngx-skeleton-loader>
                        </div>
                        <div class="column is-1"></div>
                    </div>
                </ng-container>
            </ng-container>
        </ng-template>
    </div>
</ng-container>

<ng-template #notAllowed>
    <div class="no-permissions">
        <mat-card appearance="outlined" class="centered">
            <mat-card-header>
                <mat-card-title>
                    <span>Unzureichende Berechtigungen</span>
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>
                    Sie verfügen nicht über die notwendigen Berechtigungen, um die Berechtigungen für Bestellungen bearbeiten zu können.
                </p>
                <p>
                    Bitte wenden Sie sich an den Administrator Ihrer Gesellschaft.
                </p>
            </mat-card-content>
        </mat-card>
    </div>
</ng-template>
